
import { Icon } from "react-icons-kit";
import {facebook} from 'react-icons-kit/icomoon/facebook'
const Facebook = () => {
    return (
            <Icon icon={facebook} size={20} />
    );
};

export default Facebook;